<template>
  <f7-block>
    <div
      class="content-devx"
    >
      <DxDataGrid
        id="attributesTemplateForm-datagrid"
        :data-source="attributes"
        :column-min-width="70"
        :column-auto-width="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :row-alternation-enabled="false"
        @toolbar-preparing="onToolbarPreparing($event)"
        @exporting="onExporting"
        @row-removed="deleteAttribute"
      >
        <DxSelection
          mode="single"
        />
        <DxStateStoring
          :enabled="true"
          type="localStorage"
          storage-key="attributesTemplateForm"
        />
        <DxHeaderFilter :visible="true" />
        <DxExport
          :enabled="false"
        />
        <DxPaging :page-size="10" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="pageSizes"
          :show-info="true"
        />
        <DxSearchPanel
          :visible="true"
          :width="200"
          :placeholder="$t('Search_placeholder')"
        />
        <DxEditing
          :allow-updating="true"
          :allow-deleting="true"
          :confirm-delete="true"
          mode="popup"
        >
          <DxTexts
            :confirm-delete-message="$t('Confirm_Delete_Text')"
            :confirm-delete-title="$t('Confirm_Delete_Title')"
          />
        </DxEditing>
        <DxColumn
          data-field="description"
          :caption="$t('Configuration.ObservationsForms.description')"
          :allow-header-filtering="false"
          alignment="left"
        />
        <DxColumn
          data-field="type"
          :caption="$t('Configuration.ObservationsForms.tipology')"
          :allow-header-filtering="false"
          alignment="left"
          :calculate-display-value="displayTranslatedType"
        />
        <DxColumn
          type="buttons"
        >
          <DxButton
            name="find"
            icon="find"
            :on-click="viewAttribute"
          />
          <DxButton
            name="edit"
            icon="edit"
            :on-click="editAttribute"
          />
          <DxButton
            name="delete"
            icon="trash"
          />
        </DxColumn>
        <template #titleAttributesForms>
          {{ $t('Configuration.ObservationsForms.attributesTitle') }}
        </template>
      </DxDataGrid>
      <AttributesPopup
        v-if="showAttributePopup"
        :current-attribute="currentAttribute"
      />
    </div>
  </f7-block>
</template>

<script>

import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxHeaderFilter,
  DxStateStoring,
  DxPager,
  DxSelection,
  DxEditing,
  DxButton,
  DxTexts,
} from 'devextreme-vue/data-grid';
import { exportDataGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { mapState, mapActions } from 'vuex';
import moment from 'moment-timezone';
import AttributesPopup from '../attributesPopup/index.vue';

export default {
  name: 'AttributesTemplateForm',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxHeaderFilter,
    DxStateStoring,
    DxPager,
    DxSelection,
    DxEditing,
    DxButton,
    AttributesPopup,
    DxTexts,
  },
  props: {
    attributes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pageSizes: [5, 10, 20],
    };
  },
  computed: {
    ...mapState('Observations', ['showAttributePopup', 'currentAttribute']),
  },
  methods: {
    viewAttribute(attribute) {
      this.initCurrentAttribute();
      this.setCurrentAttribute(attribute.row.data);
      this.setReadOnly(true);
      this.setShowAttributePopup(true);
    },
    editAttribute(attribute) {
      this.initCurrentAttribute();
      this.setCurrentAttribute(attribute.row.data);
      this.setReadOnly(false);
      this.setShowAttributePopup(true);
    },
    displayTranslatedType(attribute) {
      return `${this.$t(`Configuration.AttributesPopup.type${attribute.type}`)}`;
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'before',
        template: 'titleAttributesForms',
      }, {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          elementAttr: {
            class: 'add-task',
          },
          onClick: () => {
            this.setReadOnly(false);
            this.initCurrentAttribute();
            this.updateCurrentAttribute({ attributeKey: 'field', value: `${moment().format('YYYYMMDDHHMMss')}${(Math.floor(Math.random() * 1000) + 1)}` });
            this.setShowAttributePopup(true);
          },
        },
      });
    },
    onExporting(e) {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('AttributesTemplate');
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer()
          .then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AttributesTemplate.xlsx');
          });
      });
      e.cancel = true;
    },
    ...mapActions('Observations', ['setShowAttributePopup', 'setCurrentAttribute', 'initCurrentAttribute', 'deleteAttribute', 'setReadOnly', 'updateCurrentAttribute']),
  },
};
</script>
<style lang="scss" scoped>
@import './AttributesTemplateForm.styles.scss';
</style>
